import React, { useState, useRef, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import imageBorder from "../../assets/images/bestsellerborder.webp";
import { Pagination, useMediaQuery } from "@mui/material";
import { useNavigate, useParams } from 'react-router-dom';
import BlogSearchBar from "./BlogSearchBar";
import { BLOG_CATEGORY_DETAILS_API, GET_BLOG_CATEGORY_API } from "../../config/config";
import axios from "axios";

const BlogList = ({
  blogpageData,
  currentPage,
  handlePageChange,
  totalPages,
  setmaxrecord,
  maxrecord,
}) => {

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [visibleCount, setVisibleCount] = useState();
  const [blogCategory, setBlogCategory] = useState([]);
  const [blogDescription, setBlogDescription] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [filteredBlogs, setFilteredBlogs] = useState([]);
  const [cateBlogDes, setCateBlogDes] = useState([]);
  const [selectedCategoryPage, setSelectedCategoryPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1)
  const navigate = useNavigate();
  const { categoryname } = useParams();


  const fetchBlogCategory = async () => {
    try {
      const response = await axios.get(`${GET_BLOG_CATEGORY_API}`);
      if (response?.data?.blogCategory) {
        setBlogCategory(response.data.blogCategory);
      }
      if (response?.data?.blogDescription) {
        setBlogDescription(response.data.blogDescription[0]);
      }
    } catch (error) {
      console.error("Error fetching blog data:", error);
    }
  };

  const fetchBlogsByCategory = async (categorySlug, page = 1, limit = maxrecord) => {
    try {
      const response = await axios.post(`${BLOG_CATEGORY_DETAILS_API}`, {
        slug: categorySlug,
        page: page,
        maxrecord: limit
      }, {
        headers: { 'Content-Type': 'application/json' }
      });

      console.log("API Payload Sent: ", { slug: categorySlug, page, limit });
      console.log("API Response: ", response.data);

      if (response?.data?.blogList?.data) {
        setFilteredBlogs(response.data.blogList.data);
        setTotalPage(response.data.blogList.last_page);
      }
      if (response?.data?.blogcategory) {
        setCateBlogDes(response.data.blogcategory);
      }
    } catch (error) {
      console.error("Error fetching category blogs:", error);
    }
  };


  useEffect(() => {
    if (selectedCategory) {
      fetchBlogsByCategory(selectedCategory, selectedCategoryPage, maxrecord);
    }
  }, [maxrecord]);

  useEffect(() => {
    fetchBlogCategory();
    if (searchQuery) {
      setVisibleCount(12); // Reset to 12 for new searches
    }
  }, [searchQuery]);

  useEffect(() => {
    if (blogCategory.length > 0) { // once category list loaded
      if (categoryname) { // if URL has /blog/:categoryname
        const isValid = blogCategory.find(cat => cat.category_slug === categoryname);
        if (isValid) {
          setSelectedCategory(categoryname);
          fetchBlogsByCategory(categoryname, 1);
        } else {
          setSelectedCategory("");
          setFilteredBlogs(null); // reset
          navigate('/blog'); // optional: redirect to all blogs
        }
      } else {
        setSelectedCategory("");
        setFilteredBlogs(null);
      }
    }
  }, [categoryname, blogCategory]);

  useEffect(() => {
    fetchBlogCategory();
  }, []);


  const handleCategoryChange = (e) => {
    const selectedSlug = e.target.value;
    setSelectedCategory(selectedSlug);
    setSelectedCategoryPage(1); // Reset page to 1

    if (selectedSlug !== "") {
      navigate(`/blog/${selectedSlug}`);

      fetchBlogsByCategory(selectedSlug, 1, maxrecord); // Pass limit
    } else {
      navigate('/blog');
      setFilteredBlogs(null); // Reset blogs
    }
  };


  const handleCategoryPageChange = (event, page) => {
    setSelectedCategoryPage(page);
    fetchBlogsByCategory(selectedCategory, page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const displayedData = selectedCategory
  //   ? filteredBlogs // even if empty, show this result
  //   : searchQuery
  //     ? searchResults.slice(0, visibleCount)
  //     : Array.isArray(blogpageData)
  //       ? blogpageData.slice()
  //       : Object.values(blogpageData);
  const displayedData = searchQuery
    ? searchResults.slice(0, visibleCount)
    : selectedCategory
      ? filteredBlogs
      : Array.isArray(blogpageData)
        ? blogpageData.slice()
        : Object.values(blogpageData);



  const blogBgRef = useRef(null);
  const handlePaginationChange = (event, page) => {
    handlePageChange(event, page);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    if (blogBgRef.current) {
      blogBgRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");

  return (
    <>
      <div className="blog-bg py-5">
        <div className="d-flex flex-column">
          {/* {/ Search Bar /} */}
          <div className="search-bar">
            <BlogSearchBar
              setSearchResults={setSearchResults}
              setSearchQuery={setSearchQuery}
              setVisibleCount={setVisibleCount}
            />
          </div>


        </div>
        <div className="d-flex flex-wrap align-items-center justify-content-start gap-3 mb-4 pt-2">
          {/* Blog maxrecord Selector */}
          <div className="d-flex align-items-center mt-5 mt-md-5 mt-lg-0">
            <label className="fw-medium px-2 mb-0">
              Blogs Limits :-
            </label>
            <Form.Select
              aria-label="Select Blog maxrecord"
              value={maxrecord}
              onChange={(e) => setmaxrecord(Number(e.target.value))}
              className="select-limit-blog"
              style={{ width: "170px", borderRadius: "20px" }}
            >
              <option value="12">---Select Blogs---</option>
              <option value="10">Show 10</option>
              <option value="20">Show 20</option>
              <option value="50">Show 50</option>
              <option value="100">Show 100</option>
              <option value="150">Show 150</option>
              <option value="200">Show 200</option>
              <option value="300">Show 300</option>
              <option value="500">Show 500</option>
            </Form.Select>
          </div>

          {/* Blog Category Dropdown */}
          <div className="d-flex align-items-center mt-0 mt-sm-0 mt-md-5 mt-lg-0">
            <label className="fw-medium px-2 mb-0">
              Blogs Category :-
            </label>
            <Form.Select
              aria-label="Select Blog Category"
              value={selectedCategory}
              onChange={handleCategoryChange}
              style={{ width: "200px", borderRadius: "20px" }}
              className="select-limit-blog"
            >
              <option value="">-- Select Blog Category --</option>
              {blogCategory.map((cat) => (
                <option key={cat.id} value={cat.category_slug}>
                  {cat.category_name}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>



        <Container className="mt-lg-4 padding-blog">
          <Row>
            <div className="text-center pt-4 saree-heading">
              Our Latest Blog
            </div>
            <div className="d-flex justify-content-center">
              <img
                src={imageBorder}
                className="border-image py-2"
                alt="border"
                loading="lazy"
              />
            </div>
            <div className="d-flex align-items-center justify-content-center px-lg-5">
              <p className="text-center">
                Our team has helped 10,000+ entrepreneurs launch their
                businesses worldwide...
              </p>
            </div>

            {/* {/ Blog List with View More/Less /} */}
            {displayedData.length > 0 ? (
              displayedData.slice(0, visibleCount).map((blog, i) => {
                const metaUrl = blog?.meta_url
                  ? blog.meta_url
                    .replace(/\s+/g, "-")
                    .replace(/~/g, "-")
                    .replace(/\u200C/g, "")
                    .toLowerCase()
                  : null;

                const finalUrl = `/${blog?.url || metaUrl || "#"}`;

                // Skip rendering if final URL is invalid
                if (!finalUrl || finalUrl === "/blog/#") return null;

                return (
                  <Col lg={4} md={6} sm={12} className="mb-4 mt-lg-2" key={i}>
                    <div className="d-flex justify-content-center">
                      <Card
                        className="text-dark bloglist them-borderradius theme-shadow"
                        style={{ width: "24rem" }}
                      >
                        <div onClick={() => window.open(finalUrl, "_blank")} style={{ cursor: "pointer" }}>
                          <Card.Img
                            variant="top"
                            src={blog.image}
                            className="card-radius img-fluid"
                            alt={`blog-image-${i}`}
                            style={{ aspectRatio: "10/5" }}
                            loading="lazy"
                          />
                          <Card.Body>
                            <p className="text-center text-wrap">
                              {blog.description || blog.blog_name || blog.name}
                            </p>
                          </Card.Body>
                        </div>
                      </Card>
                    </div>
                  </Col>
                );
              })
            ) : (
              <div className="p-4 text-center fw-bold not-found">
                {selectedCategory ? "No Blog Available for this Category" : "No Blogs Found"}
              </div>
            )}

            {/* {/ View More / View Less Buttons /} */}
            {searchQuery && displayedData.length > 0 && (
              <div className="text-center mt-3">
                {visibleCount < searchResults.length ? (
                  <button
                    className="btn-red-to-black-color-move rounded-4"
                    onClick={() => setVisibleCount((prev) => prev + 12)}
                  >
                    <span> View More</span>
                  </button>
                ) : (
                  <button
                    className="btn-red-to-black-color-move rounded-4"
                    onClick={() => setVisibleCount(12)}
                  >
                    <span> View Less</span>
                  </button>
                )}
              </div>
            )}
            {/* <div className="p-4 text-center" dangerouslySetInnerHTML={{ __html: selectedCategory ? cateBlogDes?.description : blogDescription?.description }}></div> */}
            {searchQuery === "" && (
              <div
                className="p-4 text-center"
                dangerouslySetInnerHTML={{
                  __html: selectedCategory
                    ? cateBlogDes?.description
                    : blogDescription?.description,
                }}
              ></div>
            )}


            {/* {/ Pagination (Only show if not searching) /} */}
            {!searchQuery && selectedCategory && filteredBlogs ? (
              <div className="pagination-controls">
                <Pagination
                  count={totalPage}
                  page={selectedCategoryPage}
                  onChange={handleCategoryPageChange}
                  variant="outlined"
                  shape="rounded"
                  siblingCount={1}
                  boundaryCount={isMobile ? 0 : 1}
                  showFirstButton={!isMobile}
                  showLastButton={!isMobile}
                  sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "black",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#333",
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "red",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "darkred",
                      },
                    },
                  }}
                />
              </div>
            ) : !searchQuery && !selectedCategory && (
              <div className="pagination-controls">
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  onChange={handlePaginationChange}
                  variant="outlined"
                  shape="rounded"
                  siblingCount={1}
                  boundaryCount={isMobile ? 0 : 1}
                  showFirstButton={!isMobile}
                  showLastButton={!isMobile}
                  sx={{
                    display: "flex",
                    flexWrap: "nowrap",
                    overflowX: "auto",
                    "& .MuiPaginationItem-root": {
                      backgroundColor: "black",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "#333",
                      },
                    },
                    "& .Mui-selected": {
                      backgroundColor: "red",
                      color: "white",
                      "&:hover": {
                        backgroundColor: "darkred",
                      },
                    },
                  }}
                />
              </div>
            )}

          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogList;